"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = _interopRequireDefault(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

require("./ink.sass");

var _ref2 = _react.default.createElement("i", {
  className: "ink-fill ink-fill--focused"
});

var Ink =
/*#__PURE__*/
function (_React$PureComponent) {
  (0, _inherits2.default)(Ink, _React$PureComponent);

  function Ink(props, context) {
    var _this;

    (0, _classCallCheck2.default)(this, Ink);
    _this = (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(Ink).call(this, props, context));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this)), "state", {
      isClicked: false,
      isFocused: false
    });
    _this.onMouseDown = _this.onMouseDown.bind((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this)));
    _this.onMouseUp = _this.onMouseUp.bind((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this)));
    _this.onTransitionEnd = _this.onTransitionEnd.bind((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this)));
    _this.ref = _this.ref.bind((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this)));
    return _this;
  }

  (0, _createClass2.default)(Ink, [{
    key: "ref",
    value: function ref(element) {
      this.element = element;
    }
  }, {
    key: "onMouseDown",
    value: function onMouseDown(e) {
      var rect = this.element.getBoundingClientRect();
      this.setState({
        animating: false,
        down: true,
        active: true,
        x: e.clientX - rect.left,
        y: e.clientY - rect.top,
        w: rect.width,
        h: rect.height
      });
      window.addEventListener('mouseup', this.onMouseUp, true);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      window.removeEventListener('mouseup', this.onMouseUp, true);
    }
  }, {
    key: "onMouseUp",
    value: function onMouseUp() {
      window.removeEventListener('mouseup', this.onMouseUp, true);
      this.setState({
        down: false,
        animating: true,
        isClicked: true
      });
    }
  }, {
    key: "onTransitionEnd",
    value: function onTransitionEnd() {
      this.setState(function (_ref) {
        var down = _ref.down;
        return {
          animating: down,
          active: down
        };
      });
    }
  }, {
    key: "renderInkFill",
    value: function renderInkFill() {
      var _this2 = this;

      var _this$state = this.state,
          down = _this$state.down,
          animating = _this$state.animating,
          x = _this$state.x,
          y = _this$state.y,
          w = _this$state.w,
          h = _this$state.h;
      var size = 2 * Math.sqrt(w * w + h * h);
      var style = {
        opacity: down ? .1 : 0,
        width: size,
        height: size,
        transform: "translate(-50%, -50%) translate(".concat(x, "px, ").concat(y, "px)") + (animating ? '' : ' scale(0.0001, 0.0001)')
      };
      var className = 'ink-fill';

      if (animating) {
        className += ' ink-fill--animating';
      } else {
        setTimeout(function () {
          _this2.setState({
            animating: true
          });
        }, 0);
      }

      return _react.default.createElement("i", {
        className: className,
        style: style,
        onTransitionEnd: this.onTransitionEnd
      });
    }
  }, {
    key: "renderFocusedInkFill",
    value: function renderFocusedInkFill() {
      return _ref2;
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          primary = _this$props.primary,
          greyscale = _this$props.greyscale,
          className = _this$props.className,
          children = _this$props.children;
      var _this$state2 = this.state,
          isFocused = _this$state2.isFocused,
          isClicked = _this$state2.isClicked;
      var renderFocus = isFocused && !isClicked;
      var props = {
        ref: this.ref,
        onMouseDown: this.onMouseDown,
        className: (0, _classnames.default)('ink', className, {
          'ink--primary': primary,
          'ink--greyscale': greyscale
        })
      };

      if (this.state.active) {
        return _react.default.createElement("span", props, this.renderInkFill(), children);
      }

      if (renderFocus) {
        return _react.default.createElement("span", props, this.renderFocusedInkFill(), children);
      }

      return _react.default.createElement("span", props, children);
    }
  }], [{
    key: "getDerivedStateFromProps",
    value: function getDerivedStateFromProps(nextProps, prevState) {
      var blured = prevState.isFocused && !nextProps.focused;
      var shoudRemoveIsClicked = !blured;
      var isClicked = prevState.isClicked === true ? shoudRemoveIsClicked : prevState.isClicked;
      return {
        isFocused: nextProps.focused,
        isClicked: isClicked
      };
    }
  }]);
  return Ink;
}(_react.default.PureComponent);

exports.default = Ink;